module.exports = __webpack_public_path__ + "static/media/information_Patient_1.0.fa069f94.md";